import { render, staticRenderFns } from "./LeadAgeingReport.vue?vue&type=template&id=c328892c"
import script from "./LeadAgeingReport.vue?vue&type=script&lang=js"
export * from "./LeadAgeingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports